var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RECEIVE_USER_RATINGS } from '../actions/userRatings';
var initialStore = {
    userRatingsByUserId: {}
};
var userRatings = function (state, action) {
    var _a;
    if (state === void 0) { state = initialStore; }
    switch (action.type) {
        case RECEIVE_USER_RATINGS:
            return __assign(__assign({}, state), { userRatingsByUserId: __assign(__assign({}, state.userRatingsByUserId), (_a = {}, _a[action.userId] = action.userRatings, _a)) });
        default:
            return state;
    }
};
export default userRatings;
